<template>
  <div
    :class="disabled?'batch-operate-item batch-operate-item--disabled':'batch-operate-item'"
    @click="onClick"
  >
    <div class="batch-operate-item__icon">
      <slot name="icon"></slot>
    </div>
    <div class="batch-operate-item__text">{{text}}</div>
  </div>
</template>
<style lang="less" scoped>
.batch-operate-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &__icon {
    position: relative;
    font-size: 20px;
  }

  &__text {
    font-size: 10px;
  }

  &--disabled {
    pointer-events: none;
    color: rgba(229, 229, 229, 1);
  }
}
</style>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show() {
      return this.selectedKeys.length > 0;
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>